// react
import React, { Component, useState } from "react";

// third-party
import classNames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import StroykaSlick from "../shared/StroykaSlick";
import ReactPlayer from 'react-player/youtube'

// application
import departmentsAria from "../../services/departmentsArea";
import languages from "../../i18n";
import { useWindowSize } from "../../services/utils";

export const SlickArrowLeft = ({ className, style, onClick }) => {
    const windowSize = useWindowSize()
    return (
        <div
            className={className}
            style={{ ...style, display: windowSize.width < 576 ? "none" : "block" }}
            onClick={onClick}
        />
    );
}
export const SlickArrowRight = ({ className, style, onClick }) => {
    const windowSize = useWindowSize()
    return (
        <div
            className={className}
            style={{ ...style, display: windowSize.width < 576 ? "none" : "block" }}
            onClick={onClick}
        />
    );
}

// YouTube may refuse to play embeds ("Sign in to confirm you're not a bot") for some
// networks/IPs. Use the privacy-enhanced domain, send our origin, and fall back to a
// plain link if the player reports an error.
const SafeVideoPlayer = ({ url }) => {
    const [failed, setFailed] = useState(false);

    return (
        <>
            <ReactPlayer
                controls
                playsinline
                width={"100%"}
                height={"600px"}
                url={url}
                onError={() => setFailed(true)}
                config={{
                    youtube: {
                        playerVars: {
                            rel: 0,
                            origin: window.location.origin,
                        },
                        embedOptions: {
                            host: "https://www.youtube-nocookie.com",
                        },
                    },
                }}
            />
            {failed && (
                <p className="mt-2">
                    <a href={url} target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-youtube mr-1" aria-hidden="true"></i>
                        Watch on YouTube
                    </a>
                </p>
            )}
        </>
    );
};

const slickSettings = {
    infinite: true,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 7000,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <SlickArrowLeft currentSlide={undefined} slideCount={undefined} />,
    nextArrow: <SlickArrowRight currentSlide={undefined} slideCount={undefined} />,
};

class BlockVideoSlideShow extends Component {
    departmentsAreaRef = null;

    media = window.matchMedia("(min-width: 992px)");

    componentDidMount() {
        if (this.media.addEventListener) {
            this.media.addEventListener("change", this.onChangeMedia);
        } else {
            // noinspection JSDeprecatedSymbols
            this.media.addListener(this.onChangeMedia);
        }
    }

    componentWillUnmount() {
        departmentsAria.area = null;

        if (this.media.removeEventListener) {
            this.media.removeEventListener("change", this.onChangeMedia);
        } else {
            // noinspection JSDeprecatedSymbols
            this.media.removeListener(this.onChangeMedia);
        }
    }

    onChangeMedia = () => {
        if (this.media.matches) {
            departmentsAria.area = this.departmentsAreaRef;
        }
    };

    setDepartmentsAreaRef = (ref) => {
        this.departmentsAreaRef = ref;

        if (this.media.matches) {
            departmentsAria.area = this.departmentsAreaRef;
        }
    };

    render() {
        const { locale, withDepartments, banners } = this.props;
        const { direction } = languages[locale];

        const blockClasses = classNames("block-slideshow block", {
            "block-slideshow--layout--full": !withDepartments,
            "block-slideshow--layout--with-departments": withDepartments,
        });

        const layoutClasses = classNames("col-12", {
            "col-lg-12": !withDepartments,
            "col-lg-9": withDepartments,
        });

        const slides =
            banners?.length > 0 ? (
                banners.map((slide, index) => {
                    return (
                        <div
                            key={index}
                            className={"block-slideshow__slide" + (slide.link ? " c-pointer" : "")}
                            onClick={
                                slide.link
                                    ? () => {
                                        this.openSlideLink(slide.link);
                                    }
                                    : () => { }
                            }
                        >
                            <SafeVideoPlayer url={slide.media_url} />
                            <div className="video-title"><h6><FormattedMessage id={slide.title} /></h6></div>
                        </div>
                    );
                })
            ) : (
                <div className="block-slideshow__slide">
                    <img
                        className="block-slideshow__slide-image block-slideshow__slide-image--desktop"
                        src={"/images/no_banner.jpeg"}
                        alt={"banner-image-desktop"}
                    />
                </div>
            );

        return banners ? (
            <div className={"container"}>
                <h4 className="mt-5">
                    <FormattedMessage id="videoSection.title" defaultMessage="Hup Soon Recommended Recipe" />
                </h4>

                <div className={blockClasses}>
                    <div className="row no-gutters">
                        {withDepartments && <div className="col-3 d-lg-block d-none" ref={this.setDepartmentsAreaRef} />}

                        <div className={layoutClasses}>
                            <div className="block-slideshow__body">
                                <StroykaSlick {...slickSettings}>{slides}</StroykaSlick>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ) : null;
    }
}

BlockVideoSlideShow.propTypes = {
    withDepartments: PropTypes.bool,
    /** current locale */
    locale: PropTypes.string,
};

BlockVideoSlideShow.defaultProps = {
    withDepartments: false,
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(BlockVideoSlideShow);
